module.exports = __webpack_public_path__ + "static/hero-header-illustration-d-0478c0ca22e99fb324fa833b7b66e69b.svg";